<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('人物筛选')" :btnName="$i18n.$t('查询')" :fields="fields" @search="search" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content hasName" style="position: relative;">
        <VisIndex :data="relationData" lineDisableClick />
        <div class="page-common-container-right-content-no-data" v-if="relationData && relationData.data.length === 0 && relationData.link.length === 0">
          <img src="@/assets/map/no-data.png" alt="">
          <p>{{ $i18n.$t('没有查询到相关的记载') }}</p>
        </div>
      </div>
      <div class="page-common-container-right-list hasName">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!relationData.data.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
          <div class="page-common-container-right-list-title-bottom">
            {{ $i18n.$t('本次图谱共查询到') }}{{ relationTotal }}{{ $i18n.$t('节点有') }}{{ recordCount }}{{ $i18n.$t('条记载关系。全部数据请点击“下载数据”按钮导出。') }}
          </div>
        </div>
        <div class="page-common-container-right-list-content">
          <div class="page-common-container-right-list-content-item" v-for="(per, index) in perList" :key="index">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ per.Name }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ per.count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <!-- <div class="page-common-container-right-list-content-item-table-head-th">人物名称</div> -->
                <div class="page-common-container-right-list-content-item-table-head-th">{{ $i18n.$t('记载出处') }}</div>
              </div>
              <template v-for="(link, j) in per.works">
                <div class="page-common-container-right-list-content-item-table-row" :key="j" v-if="per.showMore || (!per.showMore && j < 4)">
                  <div class="page-common-container-right-list-content-item-table-row-td">{{ link }}</div>
                  <!-- <div class="page-common-container-right-list-content-item-table-row-td" :title="link.RecordedIn">{{ link.RecordedIn }}</div> -->
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="per.works.length > 4" @click.stop="per.showMore = !per.showMore">
              <template v-if="per.showMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { personRecordedIn } from '@/api/biographie'
import { i18n } from '@/i18n'
export default {
  name: 'BiographicalHome',
  meta: {
    title: i18n.$t('传记记载')
  },
  data () {
    let sessionParams = sessionStorage.getItem('biographicalParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    const Name = localStorage.getItem('biographicalName')
    if (Name) {
      localStorage.removeItem('biographicalName')
      if (!sessionParams) {
        sessionParams = {}
      }
      sessionParams.Name = Name
    }
    return {
      fields: [
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          placeholder: i18n.$t('请输入想要了解的人物'),
          key: 'Name',
          defaultValue: sessionParams ? (sessionParams.Name || '') : null
        }
        // {
        //   type: 'select',
        //   label: i18n.$t('人物设置'),
        //   placeholder: i18n.$t('请选择'),
        //   key: 'is_extension',
        //   clearable: true,
        //   options: [
        //     { label: i18n.$t('显示所有人物'), value: '1' },
        //     { label: i18n.$t('仅显示传记人物'), value: '0' }
        //   ],
        //   defaultValue: '1'
        // }
      ],
      loading: false,
      relationData: {
        data: [],
        link: []
      },
      perList: [],
      relationTotal: 0,
      recordCount: 0,
      downloadLoading: false
    }
  },
  // created () {
  //   this.getPersonRelation({})
  // },
  methods: {
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      personRecordedIn({
        ...form,
        output: 1
      }, {
        responseType: 'blob'
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('传记记载.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    search (params) {
      sessionStorage.setItem('biographicalParams', JSON.stringify(params))
      this.getPersonRelation(params)
    },
    getPersonRelation (params) {
      this.loading = true
      personRecordedIn(params).then(res => {
        this.relationData = {
          data: [
            ...res.data.data,
            ...res.data.person
          ],
          link: res.data.link
        }
        this.$set(this.relationData, 'searchKey', params.Name)
        this.$set(this.relationData, 'condition', 'eq')
        this.recordCount = res.data.link.length
        this.relationTotal = this.relationData.data.length
        this.perList = (res.data.sidebar || []).map(e => {
          return {
            ...e,
            showMore: false
          }
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
